import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import { withBrand } from '../../../../providers/BrandProvider';
import { HTMLtoJSX } from '../../../../helpers';
import SiteUpperFooter from './SiteUpperFooter/SiteUpperFooter';
import SiteLowerFooter from './SiteLowerFooter/SiteLowerFooter';
import Advertising from '../../../shared/Advertising/Advertising';
import { selectAdvertisingPageCategory } from '../../../../utils/advertising/selectAdvertisingPageCategory';
import { getDivisionalMarketingFooterConfig } from './utils';

import {
  DivisionalMarketingFooter,
  MarketingFooter,
  DivisionalFooter,
  CopyrightFooter,
  TenantLogo,
} from '../../../../informakit';

import './SiteFooter.scss';

const FanExpoHQFooter = loadable(() =>
  import(
    /* webpackChunkName: "FanExpoHQFooter" */ '../layoutComponents/FanExpoHQFooter/FanExpoHQFooter'
  ),
);
const FestivalFooter = loadable(() =>
  import(
    /* webpackChunkName: "FestivalFooter" */ '../layoutComponents/FestivalFooter/FestivalFooter'
  ),
);
const PalmMagazineFooter = loadable(() =>
  import(
    /* webpackChunkName: "PalmMagazineFooter" */ '../layoutComponents/PalmMagazineFooter/PalmMagazineFooter'
  ),
);
const DataCenterWorldFooter = loadable(() =>
  import(
    /* webpackChunkName: "DataCenterWorldFooter" */ '../layoutComponents/DataCenterWorldFooter/DataCenterWorldFooter'
  ),
);

export class SiteFooter extends Component {
  static propTypes = {
    footerUpperHidden: PropTypes.bool,
    siteFooter: PropTypes.object,
    brand: PropTypes.object,
    pageConfig: PropTypes.object,
    pageCategory: PropTypes.string,
  };

  checkUpperFooterPresence() {
    const {
      siteFooter: { data: { contact = {}, hashtag, social = [] } = {} } = {},
      footerUpperHidden = false,
    } = this.props;

    return (
      !footerUpperHidden &&
      !(Object.keys(contact).length === 0 && !hashtag && social.length === 0)
    );
  }

  getAdvParentStyle() {
    const {
      pageConfig: { tenantConfig: { footerVariant } = {} } = {},
      brand = {},
    } = this.props;

    switch (footerVariant) {
      case 'FanExpoHQ':
      case 'FanExpo':
      case 'InteriorDesignShow':
        return { backgroundColor: '#d8d8d8' };
      case 'Festival':
        return { backgroundColor: '#d8d8d8' };
      case 'DataCenterWorld':
        return { backgroundColor: '#3f4553' };
      case 'Omdia':
        return {
          backgroundColor: '#2596BE',
        };
      default:
        return { backgroundColor: brand.secondaryColor };
    }
  }

  getSocialList() {
    const {
      siteFooter: { data: { social = [] } = {} },
    } = this.props;

    return social.map((item) => {
      return {
        type: item.type,
        href: item.url,
        brand: item.type !== 'blog',
      };
    });
  }

  renderFooter() {
    const {
      siteFooter: { data: { hashtag } = {} } = {},
      pageConfig: {
        tenantId,
        tenantConfig: { footerVariant, copyright } = {},
        location,
      } = {},
      brand = {},
    } = this.props;

    const footerSection = getDivisionalMarketingFooterConfig(tenantId);

    switch (footerVariant) {
      case 'Division':
        return (
          <DivisionalMarketingFooter>
            <MarketingFooter
              backgroundColor={brand.secondaryColor}
              bottomBorder
              eventName={hashtag ? `#${hashtag}` : 'us'}
              discoverMenu={{
                title: footerSection.discoverTitle,
                menuLeft: footerSection.menuLeft,
                menuRight: footerSection.menuRight,
              }}
              secondaryMenu={{
                title: footerSection.secondMenuTitle,
                menu: footerSection.secondaryMenu,
              }}
              socialMenu={this.getSocialList()}
            />
            <DivisionalFooter
              bottomBorder
              showPrefix
              menuItems={footerSection.divisionalFooter}
              Logo={<TenantLogo logoObj={footerSection.lowerFooter.logo} />}
            />
            <CopyrightFooter>{HTMLtoJSX(copyright, location)}</CopyrightFooter>
          </DivisionalMarketingFooter>
        );
      case 'FanExpoHQ':
      case 'FanExpo':
      case 'InteriorDesignShow':
        return (
          <footer className="c-event-footer">
            <FanExpoHQFooter bgColor={brand.secondaryColor} />
            <SiteLowerFooter />
          </footer>
        );
      case 'Festival':
        return (
          <footer className="c-event-footer">
            <FestivalFooter />
          </footer>
        );
      case 'DataCenterWorld':
        return (
          <div className="c-event-footer">
            <DataCenterWorldFooter />
          </div>
        );
      case 'Omdia':
        return (
          <footer className="c-event-footer">
            {this.checkUpperFooterPresence() && (
              <SiteUpperFooter
                data={this.props.siteFooter.data}
                styleVariant={footerVariant}
              />
            )}
            <SiteLowerFooter
              bgColor={'#2596BE'}
              logoStyles={{
                paddingTop: '8px',
                paddingBottom: '8px',
              }}
            />
          </footer>
        );
      case 'Palm':
      case 'AvIcnExpo':
        return (
          <footer className="c-event-footer">
            <PalmMagazineFooter footerVariant={footerVariant} />
          </footer>
        );

      // Do not display footer
      case 'NONE':
        return null;

      default:
        return (
          <footer className="c-event-footer">
            {this.checkUpperFooterPresence() && (
              <SiteUpperFooter
                data={this.props.siteFooter.data}
                bgColor={brand.secondaryColor}
              />
            )}
            <SiteLowerFooter bgColor={brand.primaryColor} />
          </footer>
        );
    }
  }

  render() {
    const { advertisingEnabled, pageCategory } = this.props;

    return (
      <>
        <div style={this.getAdvParentStyle()}>
          <Advertising
            advSlots={[
              { slotId: '300_1_bottom' },
              { slotId: '300_2_bottom' },
              { slotId: '300_3_bottom' },
            ]}
            enabled={advertisingEnabled}
            advSize="300_250"
            pageCategory={pageCategory}
          />
        </div>
        {this.renderFooter()}
        <Advertising
          advSlots={[{ slotId: '1_1', target: 'adhesion' }]}
          advSize="1_1"
          enabled={advertisingEnabled}
          pageCategory={pageCategory}
        />
        <Advertising
          advSlots={[{ slotId: '1_2', target: 'floor' }]}
          advSize="1_1"
          enabled={advertisingEnabled}
          pageCategory={pageCategory}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    siteFooter: state.siteFooter,
    pageConfig: state.pageConfig,
    pageCategory: selectAdvertisingPageCategory(state),
  };
}

export default connect(mapStateToProps)(withBrand(SiteFooter));
